export const GROUP_VALUE_KEY = '%VAL%';
export const AGGREGATION_NAME_KEY = 'keyName';
export const COMPOUND_KEY_SEPARATOR = '|';
